import { render, staticRenderFns } from "./LandTransferDataTab.vue?vue&type=template&id=8bbf2dde&scoped=true"
import script from "./LandTransferDataTab.vue?vue&type=script&lang=js"
export * from "./LandTransferDataTab.vue?vue&type=script&lang=js"
import style0 from "./LandTransferDataTab.vue?vue&type=style&index=0&id=8bbf2dde&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbf2dde",
  null
  
)

export default component.exports